import React from 'react';
import {render} from 'react-dom';
import {
    initDimensionsFromState,
    trackInitialPageView
} from '@eb/site-analytics';
import 'eventbrite_design_system/css/eds.css';
import './app.scss';
import App from './App';
import serverData from './mocks/serverData';

// retrieve data from server to hydrate the client
const props = window.__SERVER_DATA__ || serverData;

// render app with server props to the DOM
render(
    <App {...props} />,
    document.getElementById('root')
);

// set up initial GA tracking
initDimensionsFromState(props);
trackInitialPageView(props.gaSettings);



// WEBPACK FOOTER //
// ./src/index.js